import PropTypes from 'prop-types';
import React from 'react';
import config from 'trade-in/config/index.js';
import CBBAutoComplete from 'trade-in/components/CBBAutoComplete/CBBAutoComplete.jsx';
import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

const InstantEstimateAutocomplete = ({ onAutoCompleteSelect, selectedValue, parentClassName }) => {
    const czGroup = 'widget.tradein.teaser';
    const defaultStyleBackgroundColor = '#CD1122';
    const defaultStyleTextColor = '#ffffff';

    const styleBackgroundColor = {
        backgroundColor: ContentZonesService.getContentZone(czGroup, 'primary.background.color')
            ? ContentZonesService.getContentZone(czGroup, 'primary.background.color').getValue()
            : defaultStyleBackgroundColor,
    };
    const estimateTitle = ContentZonesService.getContentZone(czGroup, 'instant.estimate.title')
        ? ContentZonesService.getContentZone(czGroup, 'instant.estimate.title').getValue()
        : LocaleService.t('TRADE_IN.TEASER.ESTIMATE_TITLE');

    const estimateSubtitle = ContentZonesService.getContentZone(czGroup, 'instant.estimate.subtitle')
        ? ContentZonesService.getContentZone(czGroup, 'instant.estimate.subtitle').getValue()
        : LocaleService.t('TRADE_IN.TEASER.ESTIMATE_SUBTITLE');

    const styleTextColor = {
        color: ContentZonesService.getContentZone(czGroup, 'primary.text.color')
            ? ContentZonesService.getContentZone(czGroup, 'primary.text.color').getValue()
            : defaultStyleTextColor,
    };
    const imagesServer = config.source.image;
    return (
        <div className="instant-estimate__content" style={styleBackgroundColor}>
            <div className="instant-estimate__text-content">
                <div className="instant-estimate__text-wrapper">
                    <p style={styleTextColor} className="instant-estimate__content-subtitle sr-text is-light is-small">
                        {estimateSubtitle}
                    </p>
                    <p style={styleTextColor} className="instant-estimate__content-title">
                        {estimateTitle}
                    </p>
                </div>
                <CBBAutoComplete
                    onValueSelected={onAutoCompleteSelect}
                    value={selectedValue}
                    dataTestPrefix="trade-in.instant-estimate-autocomplete"
                    parentClassName={parentClassName}
                />
            </div>
            <img
                src={`${imagesServer}/images/widget/showroom/asset/canadian_black_book_monochrone.png`}
                alt={estimateTitle}
                className="teaser-cbb__image"
            />
        </div>
    );
};

InstantEstimateAutocomplete.propTypes = {
    onAutoCompleteSelect: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    parentClassName: PropTypes.string.isRequired,
};

InstantEstimateAutocomplete.displayName = 'InstantEstimateAutocomplete';

export default InstantEstimateAutocomplete;
